











































import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import {
    computed,
    defineComponent,
    onMounted,
    ref,
} from '@vue/composition-api';
import { getConfig } from '@superbet-group/web.lib.config';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import { LimitsStore } from '@store/modules/limits/limitsIndex';
import { isBelgium } from '@modules/layout/utils/isCountry';
import LimitProgress from '@walletFederation/src/ui/deposit/components/LimitProgress.vue';
import { RouteName } from '@src/app/router/constants/RouteName';
import { setChangeDepositLimitReferer } from '@src/app/shared/referer/changeDepositLimitReferer';
import {
    SdsButtonText,
    ContentLoaderSize,
    SbContentLoader,
} from '@superbet-group/web.lib.ui-components';
import { ResponsibleGamingPageElement } from '@src/config/shell/localConfigTypes';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import {
    LimitStatus,
    LimitType,
} from '@core/models/user/Limit';
import { isResponsibleGamingElementEnabled } from '@accountFederation/modules/responsibleGaming/helpers';
import {
    AnalyticsAction,
    AnalyticsEvent,
} from '@superbet-group/web.types';
import { useShowLimitsModals } from '@accountFederation/modules/responsibleGaming/components/canon/modals/useChangeLimitModal';

export default defineComponent({
    props: {
        originalSource: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const isLoading = ref(false);
        const depositLimitsProgressConfig
            = getConfig().countrySpecific.user.responsibleGaming?.depositLimitsProgress;

        const limitsStore = useVuexStore<LimitsStore>('data/authentication');
        const getLimits = limitsStore.action('getLimits');
        const depositLimits = limitsStore.getter('depositLimits');
        const pendingDepositLimit = computed(
            () =>
                depositLimits?.value?.week?.status === LimitStatus.Inactive
                && depositLimits?.value?.week?.amount,
        );
        const shouldOpenDepositLimitModal = computed(
            () => shellLocalConfig.depositLimit.hasWeeklyDepositLimitModal && !pendingDepositLimit.value,
        );

        const handleDepositLimitTracking = () => {
            setChangeDepositLimitReferer(props.originalSource);
            if (isBelgium()) {
                AnalyticsSDK.getInstance().log(
                    'Deposit_Limit',
                    {
                        eventAction: AnalyticsAction.Intent,
                        source: props.originalSource,
                    },
                );
                // Can be triggered immediately, as previously just
                // the act of mounting the modal would trigger this
                AnalyticsSDK.getInstance().log(
                    'Deposit_Limit',
                    {
                        eventAction: AnalyticsEvent.PageView,
                        source: props.originalSource,
                        eventLabel: 'modal',
                    },
                );
            }
        };

        const { showLimitModal } = useShowLimitsModals();

        const openDepositLimitModal = () => {
            showLimitModal({
                type: LimitType.Deposit,
                limit: 'week',
                currentLimits: depositLimits.value,
                canDelete: false,
            });
            handleDepositLimitTracking();
        };
        onMounted(async () => {
            isLoading.value = true;
            await getLimits();
            isLoading.value = false;
        });

        return {
            depositLimitsProgressConfig,
            depositLimits,
            openDepositLimitModal,
            shouldOpenDepositLimitModal,
            handleDepositLimitTracking,
            pendingDepositLimit,
            limitsLocation: {
                name: RouteName.Account.ResponsibleGaming,
                params: {
                    openAccordion: ResponsibleGamingPageElement.DepositLimit,
                },
            },
            isLoading,
            ContentLoaderSize,
            isLimitsChangeEnabled: isResponsibleGamingElementEnabled(ResponsibleGamingPageElement.DepositLimit),
        };
    },

    components: {
        SdsButtonText,
        LimitProgress,
        SbContentLoader,
    },
});
